import React from "react";
import { useDeleteDraftDialogContext } from "src/components/Drafts";
import { useDraftsNavigation } from "../hooks";
import { PropsType } from "./types";

export const useDraftsContextMenu = ({
  row,
  onDeleteDraftConfirmed,
}: PropsType) => {
  const { handleOnClick: handleOnClickView } = useDraftsNavigation(row);
  const { openDialog: openDeleteDraftDialog } = useDeleteDraftDialogContext();

  const handleOnClickDelete = React.useCallback(() => {
    openDeleteDraftDialog({
      onDeleteDraft: onDeleteDraftConfirmed,
    });
  }, [openDeleteDraftDialog, onDeleteDraftConfirmed]);

  return {
    handleOnClickView,
    handleOnClickDelete,
  };
};
